module.exports = __webpack_public_path__ + "img/dq_pic_data_availability_settings.37ca39b8.png";